// extracted by mini-css-extract-plugin
export default {"footerSocial":"MainFooterSocial_footerSocial__i5XTS"};